// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../../core/data/interface";

const Datatable: React.FC<DatatableProps> = ({ columns, dataSource, Selection, showPageSize = true, showSearch = true, extraToolbar, searchFilterFn, searchPlaceholder = "Ara", scroll, rowKey, selectedRowKeys: controlledSelectedRowKeys, onSelectionChange }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const [pageSize, setPageSize] = useState<number>(10);
  const [current, setCurrent] = useState<number>(1);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  useEffect(() => {
    setFilteredDataSource(dataSource);
    setCurrent(1); // Veri değişince ilk sayfaya dön
  }, [dataSource]);

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setCurrent(1); // Sayfa başına kayıt değişince ilk sayfaya dön
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const lower = value.toLowerCase().trim();
    const filteredData = searchFilterFn
      ? dataSource.filter((record) => searchFilterFn(record, value))
      : dataSource.filter((record) =>
          Object.values(record).some((field) =>
            String(field).toLowerCase().includes(lower)
          )
        );
    setFilteredDataSource(filteredData);
  };

  // selectedRowKeys dışarıdan verilirse seçim üst bileşende tutulur (örn. toplu işlem çubuğu için)
  const isSelectionControlled = controlledSelectedRowKeys !== undefined;
  const rowSelection = {
    selectedRowKeys: isSelectionControlled ? controlledSelectedRowKeys : selectedRowKeys,
    onChange: (keys: any[], rows: any[]) => {
      if (!isSelectionControlled) onSelectChange(keys);
      onSelectionChange?.(keys, rows);
    },
    // Arama/filtre ile görünmeyen satırların seçimi kaybolmasın
    preserveSelectedRowKeys: true,
  };
  useEffect(() => {
    return setSelections(Selection);
  }, [Selection])


  return (
    <div className="table-top-data">
      {(showPageSize || showSearch || extraToolbar) && (
        <div className="d-flex flex-nowrap align-items-center gap-2 gap-md-3 p-3">
          {showPageSize && (
            <div className="dataTables_length">
              <label className="mb-0">
                Sayfa Başına
                <select
                  style={{ marginLeft: "10px", marginRight: "10px", width: "50px" }}
                  value={pageSize}
                  onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                kayıt
              </label>
            </div>
          )}
          {showSearch && (
            <div className="dataTables_filter mb-0" style={{ width: "220px", flexShrink: 0 }}>
              <label className="mb-0 w-100">
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder={searchPlaceholder}
                  aria-controls="DataTables_Table_0"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          )}
          {extraToolbar && <div className="ms-auto">{extraToolbar}</div>}
        </div>
      )}

      {!Selections ?
        <Table
          className="table datanew dataTable no-footer"
          rowKey={rowKey}
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          scroll={scroll}
          pagination={{
            current,
            pageSize,
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            showSizeChanger: false,
            onChange: (page) => setCurrent(page)
          }}
        /> :
        <Table
          className="table datanew dataTable no-footer"
          rowKey={rowKey}
          rowSelection={rowSelection}
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          scroll={scroll}
          pagination={{
            current,
            pageSize,
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            showSizeChanger: false,
            onChange: (page) => setCurrent(page)
          }}
        />}
    </div>
  );
};

export default Datatable;
